import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { auth as AuthApi } from '@teem/constants/api';

@Injectable({
  providedIn: 'root'
})

export class AuthService {

    constructor(private httpClient: HttpClient) { }

    public register(params: any) {
        return this.httpClient.post(`${AuthApi.register}`, params);
    }

    public login(params: any) {
        return this.httpClient.post(`${AuthApi.login}`, params);
    }

    public verifyLogin(params: any) {
        return this.httpClient.post(`${AuthApi.verifyLogin}`, params);
    }

    public verifyOtp(params: any) {
        return this.httpClient.post(`${AuthApi.verify}`, params);
    }

    public sendOtp(params: any) {
        return this.httpClient.post(`${AuthApi.send}`, params);
    }

    public resendOtp(params: any) {
        return this.httpClient.post(`${AuthApi.resend}`, params);
    }

    public sendForgotOtp(params: any) {
        return this.httpClient.post(`${AuthApi.sendForgotOtp}`, params);
    }

    public verifyForgot(params: any) {
        return this.httpClient.post(`${AuthApi.verifyForgot}`, params);
    }

    public setPassword(params: any) {
        return this.httpClient.post(`${AuthApi.setPassword}`, params);
    }

    // public checkEmail(params: any) {
    //     return this.httpClient.get(`${AuthApi.checkEmail}`, params);
    // }

    checkEmail(email: any): Observable<any> {
        return this.httpClient.post<{ exists: boolean }>(`${AuthApi.checkEmail}`, { email });        
    }

    checkPhone(phone: any): Observable<any> {
        return this.httpClient.post<{ exists: boolean }>(`${AuthApi.checkPhone}`, { phone });        
    }
}
